exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "drawgroup-time-limit .calendar-disabled {\n  opacity: 1;\n  background-color: #dddddd; }\n\ndrawgroup-time-limit p-calendar .ui-inputtext:disabled {\n  opacity: 1;\n  background-color: #dddddd; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src14910448/src/src/app/components/businessRules/drawGroup-time-limit/drawGroup-time-limit.component.scss
// module id = ../../../../../src/app/components/businessRules/drawGroup-time-limit/drawGroup-time-limit.component.scss
// module chunks = main